<mat-card
  appearance="outlined"
  class="bg-primary-container overflow-hidden"
>
  <mat-card-content class="al-wrapper">
    <mat-spinner [diameter]="50" />
    <img
      src="../../../../assets/images/logo/home-logo.png?version=#{versionNumber}#"
      alt=""
    />
  </mat-card-content>
</mat-card>
